import { CategoryGroupAddProductPage } from "@/features/category-group/pages/CategoryGroupAddProductPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/category-group/$id/category/$categoryID/add-product",
)({
	component: RouteComponent,
});

function RouteComponent() {
	const { id, categoryID } = Route.useParams();
	return <CategoryGroupAddProductPage id={id} categoryID={categoryID} />;
}
